import {Component, effect, inject, model, OnDestroy, Signal, signal, WritableSignal} from '@angular/core';
import {ControlStore, EControlActions, IControlDataChanged, IControlObject} from 'frontier/nucleus';
import {DunningConfigTableComponent} from './dunning-config-table/dunning-config-table.component';
import {DunningsEditorComponent} from '../template-editor/dunnings-editor.component';
import {LanguageCheckService, TDBObject} from '../../../api/generated';
import {filter, tap} from 'rxjs/operators';
import ControlGuids from '../../../api/ControlGuids';
import {Subscription} from 'rxjs';
import {AlertService} from '../language-config/alert.service';

@Component({
  selector: 'app-dunning-config',
  templateUrl: './dunning-config.component.html',
  styleUrl: './dunning-config.component.scss',
  standalone: true,
  imports: [DunningsEditorComponent, DunningConfigTableComponent],
})
export class DunningConfigComponent implements OnDestroy {
  private _languageCheckService: LanguageCheckService = inject(LanguageCheckService);
  private _controlStore: ControlStore = inject(ControlStore);
  private subs: Subscription = new Subscription();
  private _alertService: AlertService = inject(AlertService);

  alertObjects: Signal<IControlObject[]> = this._alertService.dunningAlertObjects.asReadonly();
  dunningConfigSelectedSource: WritableSignal<IControlObject> = signal<IControlObject>(null);

  constructor() {
    this.subs.add(
      this._controlStore.controlDataChanged$.pipe(
        filter((evt: IControlDataChanged): boolean => {
          return new Map([
            [ControlGuids.TLanguageTable, new Set([
              EControlActions.edit,
              EControlActions.delete,
              EControlActions.create,
              EControlActions.changeLine,
            ])],
          ]).get(evt.GUID)?.has(evt.changeType);
        }),
        tap((): void => {
          this.refetchAlertObjects();
        })).subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  filterDunningLevels(evt: TDBObject): void {
    this.dunningConfigSelectedSource.set(evt);
  }

  getAlertOverview(): string {
    return 'Bei folgenden Mahnungskonfigurationen sind zumindest manche Mahnstufen nicht für die aktuelle ' +
      'Standardsprache konfiguriert: ' +
      this.alertObjects().map((a: IControlObject): string => a.name).join(', ');
  }

  refetchAlertObjects(): void {
    this._languageCheckService.languageCheckGetChangesNeededForDunning()
      .subscribe((res: TDBObject[]): void => this._alertService.dunningAlertObjects.set(res));
  }
}
